// Frontend view model only, NOT a backend wire contract. The future adapter must
// map the published unified roster into this shape; never merge partial lists.
export const presenceState = value => ['online', 'offline'].includes(value) ? value : 'unknown';

export function projectRoster(snapshot){return {whatsappLink:snapshot?.whatsappLink||null,staff:(snapshot?.staff||[]).map(row=>({userId:row.userId,displayName:row.displayName,pfp:row.pfp,srmPresence:presenceState(row.srmPresence)}))};}
const confirmedTransition=(before,after)=>presenceState(before)!=='unknown'&&presenceState(after)!=='unknown'&&before!==after;
export function rosterTransitions(previous,next){if(!previous||!next)return [];const old=projectRoster(previous).staff;return projectRoster(next).staff.flatMap(row=>{const before=old.find(item=>String(item.userId)===String(row.userId));return before&&confirmedTransition(before.srmPresence,row.srmPresence)?[{entity:`staff:${row.userId}:srmPresence`,name:row.displayName,presence:row.srmPresence}]:[];});}

// Injected transport is deliberately not wired until backend publishes its
// endpoint/subscription. Each subscribe returns cleanup. deliveryKey must be a
// stable occurrence identity supplied by that adapter, not a guessed timestamp.
export function bindStaffRoster({ transport, publish, notify, claimNotification = () => false }) {
  let active = true;
  let generation = 0;
  let previous = null;
  let stopSnapshots;
  function reconnect() {
    const current = ++generation;
    stopSnapshots?.();
    previous = null;
    publish(null);
    const receive = ({ snapshot, deliveryKey }) => {
      if (!active || current !== generation || !snapshot) return;
      const transitions = rosterTransitions(previous, snapshot);
      previous = snapshot;
      publish(snapshot);
      if (notify && deliveryKey) transitions.forEach(change => {
        if (claimNotification(`${deliveryKey}:${change.entity}`)) notify(change);
      });
    };
    stopSnapshots = transport.subscribe(receive);
    // The adapter must order its initial complete snapshot and subsequent
    // updates. No separate HTTP fetch can race and overwrite newer snapshots.
  }
  const stopReconnect = transport.onReconnect(reconnect);
  reconnect();
  return () => { active = false; generation++; stopSnapshots?.(); stopReconnect(); };
}
